import { ISuccessfulAuth } from '../../../interfaces';
import React, { useContext } from 'react';
import { MainContext } from '../../../context/main.context';
import ManualController from '../../../hoc/ManualController';
import FacebookLogin, { FailResponse, ProfileSuccessResponse } from '@greatsumini/react-facebook-login';
import { LOGIN_BY_FACEBOOK_ERROR, LOGIN_BY_FACEBOOK_SIGN_IN_ERROR } from '../../../common/errorCodes';
import { facebookLogin } from '../../../stores/auth.store';

const EXCEPTION_ERROR_LOGIN_CANCELLED: string = 'loginCancelled';

export default function FacebookAuth(): JSX.Element {
    const { toggleLoader } = useContext(MainContext);
    const { manualRedirect } = ManualController();

    const _onFail = (err: FailResponse) => {
        if (err?.status === EXCEPTION_ERROR_LOGIN_CANCELLED) {
            toggleLoader(false);
        } else {
            manualRedirect(err, 'auth', true, LOGIN_BY_FACEBOOK_SIGN_IN_ERROR);
        }
    }

    const _onProfileSuccess = (profile: ProfileSuccessResponse) => {
        _facebookLogin(profile);
    }

    const _facebookLogin = (profile: ProfileSuccessResponse): void => {
        facebookLogin(profile).then((res: { data: ISuccessfulAuth }) => {
            const result = res?.data?.result;

            if (result) {
                manualRedirect(result, 'auth');
                return;
            }

            manualRedirect(res, 'auth', true, LOGIN_BY_FACEBOOK_ERROR);
        }, (err: any) => {
            const errData = err?.response?.data || err;

            manualRedirect(errData, 'auth', true, LOGIN_BY_FACEBOOK_ERROR);
        }).finally((): void => {
            toggleLoader(false);
        });
    }

    const _onClick = () => {
        toggleLoader(true);
    }

    return (
        <div className="auth-id" onClick={_onClick}>
            <FacebookLogin
                appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID as string}
                onFail={_onFail}
                onProfileSuccess={_onProfileSuccess}
                fields="name,id"
                scope="public_profile"
                render={({ onClick }) => (
                    <div className="auth-id" onClick={onClick}/>
                )}
            />
        </div>
    );
}